module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o2-switch",
    class: ['is-' + _vm.switchState],
    on: {
      "click": _vm.toggleState
    }
  }, [_c('div', {
    staticClass: "o2-switch-node"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aae174ee!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/switch/src/switch.vue
// module id = 205
// module chunks = 1